import React from 'react';
import { useTranslation } from 'react-i18next';

import TableCell from '@mui/material/TableCell';

import Tooltip from '@mui/material/Tooltip';
import useKeepitalRoutes from '../../../../../components/_hook/useKeepitalRoutes';
import LabelDropshippingRequestProductStatus from '../../../_module/LabelDropshippingRequestProductStatus';
import CopyIconButton from '../../../../../components/_iconButton/CopyIconButton';
import { IProductSchema } from '../../../../../../graphql/type/product';
import BaseImage from '../../../../../components/_image/BaseImage';
import useLanguage from '../../../../../components/_hook/useLanguage';
import SchemaProductPrice from '../../../../../components/_schema/SchemaProductPrice';
import ExternalLinkIconButton from '../../../../../components/_iconButton/ExternalLinkIconButton';

interface IProps {
  item: IProductSchema;
  setTableRefreshKey?: (tableRefreshKey: number) => void;
}

export default function DropshippedRequestForDropshipDetailTableItem(
  props: IProps
) {
  const { t } = useTranslation();
  const { item, setTableRefreshKey } = props;
  const { getText } = useLanguage();
  const { path: keepitalPath } = useKeepitalRoutes();
  const images = item.media && item.media.images ? item.media.images : [];
  const image = images.find((tempImage) => tempImage.status);
  const dropshippingProductRequests = item.dropshippingProductRequests || [];
  const dropshippingProductRequest = dropshippingProductRequests[0];
  return (
    <>
      <TableCell align="left">
        <Tooltip title={item._id}>
          <span>{item._id.substr(0, 6)}</span>
        </Tooltip>
        <CopyIconButton iconHtmlFontSize="0.8rem" copyText={item._id} />
      </TableCell>
      <TableCell align="left">
        {getText(item.name)}
        <ExternalLinkIconButton
          tooltip={`${t('product')} ${t('page')}`}
          href={keepitalPath('company.showcase.product.index', {
            origin:
              item.companyData && item.companyData.origin
                ? item.companyData.origin.toLowerCase()
                : '',
            companySlug:
              item.companyData && item.companyData.slug
                ? item.companyData.slug
                : '',
            productSlug: item.slug,
          })}
          target="_blank"
        />
      </TableCell>
      <TableCell align="center">
        {image ? (
          <BaseImage
            src={image.filenameSmallUrl || image.filenameUrl}
            style={{
              maxWidth: '100px',
              height: '35px',
            }}
            lightboxImages={images.map((tempImage) => tempImage.filenameUrl)}
            title={getText(item.name)}
            alt={getText(item.name)}
          />
        ) : (
          <span>{`${t('no')} ${t('image')}`}</span>
        )}
      </TableCell>
      <TableCell align="center">
        <SchemaProductPrice product={item} redRfq />
      </TableCell>
      <TableCell align="center">
        {dropshippingProductRequest ? (
          <LabelDropshippingRequestProductStatus
            status={dropshippingProductRequest.status}
          />
        ) : (
          '-'
        )}
      </TableCell>
    </>
  );
}
